import React, { useState } from "react";
import "../styles/Cryptohelppanel.css";
import { useGame } from "../GameContext";

const Helppanel: React.FC = () => {
  console.log("HelpPanel render");
  const { isHelpPanelOpen, setHelpPanelOpen } = useGame();
  const [showhelpPivots, setShowhelpPivots] = useState<string>("pivotTask");

  if (!isHelpPanelOpen) {
    return null;
  }

  return (
    <div className="crypto-helpPanel" id="crypto-helpPanel">
      <img
        src="/img/close.svg"
        id="crypto-closeButton"
        alt="Закрыть"
        className="crypto-closeButton"
        onClick={() => setHelpPanelOpen(false)}
      />
      <div className="crypto-helpPivots">
        <div
          className="crypto-selectPivots"
          id={showhelpPivots === "pivotTask" ? "crypto-activePivot" : ""}
          onClick={() => setShowhelpPivots("pivotTask")}
        >
          Задача
        </div>
      </div>
      {showhelpPivots === "pivotTask" && (
        <div id="crypto-commandsCards">
          <div className="crypto-helpCard">
            <div className="crypto-cardCaption">Суть игры</div>
            <div>
              <div>
                Необходимо разгадать шифровку.
              </div>
            </div>
          </div>
          <div className="crypto-helpCard">
            <div className="crypto-cardCaption">Правила игры</div>
            <div>
              <div>
                Разгадай шифровку и в поле для ввода введи ответ.
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default Helppanel;
